"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartProductView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const react_2 = require("react");
const react_3 = require("react");
const ProductView_1 = require("./ProductView");
const QuantityInputView_1 = require("./QuantityInputView");
const __1 = require("../..");
const Wrap = app_1.styled.li `
  display: flex;
  flex-direction: column;
  color: inherit;
  width: 100%;
  ${(_, { $loading }) => $loading
    ? (0, app_1.css) `
          opacity: 0.3;
          pointer-events: none;
        `
    : ``}
  transition: all 0.2s;
`;
function InputContext({ product, getValue, setValue }) {
    var _a;
    const { removeProduct, setQuantity, data } = (0, __1.useCart)();
    (0, react_1.useEffect)(() => {
        setValue('quantity', product.quantity);
    }, [product.quantity, setValue]);
    const cartInfo = (0, react_3.useMemo)(() => data.products.find((v) => v.id === product.id), [data, product.id]);
    const handleRemove = () => {
        void removeProduct(product.cartVariantId);
    };
    const handleChange = (0, react_2.useCallback)((quantity) => __awaiter(this, void 0, void 0, function* () {
        var _b;
        yield setQuantity((_b = cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.cartVariantId) !== null && _b !== void 0 ? _b : '', quantity, (available) => setValue('quantity', available !== null && available !== void 0 ? available : quantity));
    }), [cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.cartVariantId, setQuantity, setValue]);
    const handleBlur = (0, react_2.useCallback)((value) => Number.isNaN(value)
        ? setValue('quantity', product.quantity)
        : handleChange(value), [handleChange, product.quantity, setValue]);
    return ((0, jsx_runtime_1.jsx)(QuantityInputView_1.QuantityInputView, { value: (_a = getValue('quantity')) !== null && _a !== void 0 ? _a : product.quantity, handleRemove: handleRemove, overstock: Boolean(cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.overstock), handleBlur: handleBlur, increase: () => {
            const quantity = Number(getValue('quantity')) + 1;
            void handleChange(quantity);
        }, decrease: () => {
            const quantity = Number(getValue('quantity')) - 1;
            if (quantity === 0) {
                handleRemove();
            }
            else {
                void handleChange(quantity);
            }
        } }));
}
function CartProductView({ product, noQuantity, }) {
    const { setQuantity, data, loadingIds } = (0, __1.useCart)();
    const cartInfo = data.products.find((v) => v.id === product.id);
    if (!cartInfo) {
        return null;
    }
    if (noQuantity) {
        return ((0, jsx_runtime_1.jsx)(Wrap, Object.assign({ "$loading": Boolean(loadingIds.has(cartInfo.id)) }, { children: (0, jsx_runtime_1.jsx)(ProductView_1.ProductView, { product: product }) })));
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.Form, Object.assign({ contextOnly: true, onSubmit: ({ quantity }) => __awaiter(this, void 0, void 0, function* () {
            yield setQuantity(product.id, quantity);
            return ui_1.SubmitState.DO_NOT_CLEAR;
        }) }, { children: (0, jsx_runtime_1.jsxs)(Wrap, Object.assign({ "$loading": Boolean(loadingIds.has(cartInfo.id)) }, { children: [(0, jsx_runtime_1.jsx)(ProductView_1.ProductView, { product: product }), (0, jsx_runtime_1.jsx)(ui_1.FormContext, { children: ({ getValue, setValue }) => ((0, jsx_runtime_1.jsx)(InputContext, { product: product, getValue: getValue, setValue: setValue })) })] })) })));
}
exports.CartProductView = CartProductView;
